import * as React from "react";
const SvgLessRelevant = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<g clipPath="url(#clip0_338_93333)"><path d="M4.48626 7.83022L7.7002 4" stroke="#A6A6A6" strokeLinecap="round" /><circle cx={6} cy={6} r={5.5} stroke="#A6A6A6" strokeLinejoin="round" /></g><defs><clipPath id="clip0_338_93333"><rect width={12} height={12} fill="white" /></clipPath></defs></svg>;
export default SvgLessRelevant;